import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { saveAs } from 'file-saver';
import { format } from 'date-fns';
import { toast } from 'sonner';
import { getString } from '../components/itinerary/helpers';

export const downloadItineraryPdf = (tripInput, generatedItinerary) => {
  try {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    doc.setFontSize(20);
    doc.setFont(undefined, 'bold');
    doc.text(`${tripInput.destination_city} Travel Itinerary`, pageWidth / 2, 20, { align: 'center' });
    doc.setFontSize(12);
    doc.setFont(undefined, 'normal');
    doc.text(`Dates: ${format(new Date(tripInput.start_date), 'MMM dd')} - ${format(new Date(tripInput.end_date), 'MMM dd, yyyy')}`, 15, 35);
    doc.text(`Travelers: ${tripInput.adults} Adult(s)${tripInput.kids > 0 ? `, ${tripInput.kids} Kid(s)` : ''}`, 15, 42);
    doc.text(`Budget: ${tripInput.budget}`, 15, 49);
    let yPos = 60;
    if (generatedItinerary?.days) {
      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      doc.text('Daily Schedule', 15, yPos);
      yPos += 10;
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      generatedItinerary.days.forEach((day, index) => {
        if (yPos > 270) { doc.addPage(); yPos = 20; }
        doc.setFont(undefined, 'bold');
        doc.text(`Day ${index + 1}: ${getString(day.title) || ''}`, 15, yPos);
        yPos += 7;
        doc.setFont(undefined, 'normal');
        ['morning', 'afternoon', 'evening'].forEach((time) => {
          if (day[time]) {
            const activity = typeof day[time] === 'string' ? day[time] : getString(day[time].activity || day[time].description || day[time]);
            const lines = doc.splitTextToSize(`${time.toUpperCase()}: ${activity}`, pageWidth - 30);
            lines.forEach(line => {
              if (yPos > 280) { doc.addPage(); yPos = 20; }
              doc.text(line, 20, yPos);
              yPos += 5;
            });
            yPos += 3;
          }
        });
        yPos += 5;
      });
    }
    const pdfBlob = doc.output('blob');
    const fileName = `${tripInput.destination_city.replace(/\s+/g, '-')}-Itinerary.pdf`;
    saveAs(pdfBlob, fileName);
    toast.success('PDF downloading to your Downloads folder!');
  } catch (error) {
    toast.error('Download failed: ' + error.message);
  }
};
